export const SWIPE_STYLE = {
    float: 'left',
    position: 'fixed',
    width: '6%',
    height: '100%',
}